module.exports = __webpack_public_path__ + "public/img/penerapan manajemen kehumasan untuk menjadi humas-2.0bbc4133.png";